import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AppSettings } from '../app-settings';
import { showInvalidVersionAlertRequested } from '../store/client/client.actions';
import { invalidVersionAlertDisplayInitiated } from '../store/client/client.selectors';
import { AppState } from '../store/reducers';

const ClientVersionHeader = 'CRIS-Client-Version';
const ClientRequiredVersionHeader = 'CRIS-Client-Required-Version';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {

	constructor(private store: Store<AppState>) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(this.prepareRequest(request)).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status === 418 && error.headers.has(ClientRequiredVersionHeader)) {
					return this.store.select(invalidVersionAlertDisplayInitiated).pipe(
						mergeMap((invalidVersionAlertDisplayInitiated) => {
							if (!invalidVersionAlertDisplayInitiated) {
								this.store.dispatch(showInvalidVersionAlertRequested({ requiredVersion: error.headers.get(ClientRequiredVersionHeader) as string }));
							}
							return EMPTY;
						})
					);
				}
				return throwError(() => error);
			})
		);
	}

	private prepareRequest(request: HttpRequest<any>): HttpRequest<any> {
		return request.clone({
			headers: request.headers.append(ClientVersionHeader, AppSettings.version)
		});
	}
}